import {HStack, Tab, TabList, TabPanel, TabPanels, Tabs, Text} from "@chakra-ui/react";
import {Overview, Referral, Withdraw} from "./dashboard-panels";
import {useState} from "react";
import {ReactComponent as ListIcon} from "../../../assets/icons/profile/list.svg";
import {ReactComponent as ListWhiteIcon} from "../../../assets/icons/profile/list_white.svg";
import {ReactComponent as TrandUpIcon} from "../../../assets/icons/profile/home-dash-trend-up.svg";
import {ReactComponent as TrandUpWhiteIcon} from "../../../assets/icons/profile/home-dash-trend-up_white.svg";

export const Dashboard = ({isMobile, user}) => {
    const [tabIndex, setTabIndex] = useState(0)

    const handleTabsChange = (index) => {
        setTabIndex(index)
    }


    return (
        <Tabs
            mx={'auto'}
            w={{base: '100%',md: '80%', xm: '80%', lg : 'full'}}
            isLazy
            variant={'unstyled'}
            color={'neutral.100'}
            index={tabIndex}
            onChange={handleTabsChange}
            isFitted>
            <TabList
                display="flex"
                flexDirection={{base: "column", md: "row"}}
                alignItems={{base: "flex-start", md: "center"}}>
                <Tab
                    gap={'16px'}
                    fontSize={'body.lg'}
                    position={'relative'}
                    color={'neutral.600'}
                    justifyContent={'space-between'}
                    w={{base: 'full'}}
                    borderBottomWidth={{base: "0", md: "1px"}}
                    borderColor={{base: "neutral.1100", md: 'neutral.900'}}
                    _before={{
                        content: '""',
                        position: "absolute",
                        bottom: '3px',
                        right: 0,
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: tabIndex === 0 ? "purple.500" : 'neutral.800',
                        display: {base: "block", md: "none"}
                    }}
                    _selected={{
                        color: 'neutral.100',
                        borderColor: 'purple.500',
                        _after: {
                            content: '""',
                            position: "absolute",
                            bottom: '17px',
                            right: '7px',
                            transform: "translateY(-50%)",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "purple.500",
                            display: {base: "block", md: "none"}
                        }
                    }}>
                    <HStack>
                        {tabIndex === 0 ? <TrandUpWhiteIcon/> : <TrandUpIcon/>}
                        <Text>Overview</Text>
                    </HStack>
                </Tab>
                <Tab
                    gap={'16px'}
                    fontSize={'body.lg'}
                    justifyContent={'space-between'}
                    position={'relative'}
                    borderBottomWidth={{base: "0", md: "1px"}}
                    borderColor={{base: "neutral.1100", md: 'neutral.900'}}
                    w={{base: 'full'}}
                    color={'neutral.600'}
                    _before={{
                        content: '""',
                        position: "absolute",
                        bottom: '3px',
                        right: 0,
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: tabIndex === 1 ? "purple.500" : 'neutral.800',
                        display: {base: "block", md: "none"}
                    }}
                    _selected={{
                        color: 'neutral.100',
                        borderColor: 'purple.500',
                        _after: {
                            content: '""',
                            position: "absolute",
                            bottom: '17px',
                            right: '7px',
                            transform: "translateY(-50%)",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "purple.500",
                            display: {base: "block", md: "none"}
                        }
                    }}>
                    <HStack>
                        {tabIndex === 1 ? <ListWhiteIcon/> : <ListIcon/>}
                        <Text>Referral</Text>
                    </HStack>
                </Tab>
                <Tab
                    gap={'16px'}
                    fontSize={'body.lg'}
                    borderBottomWidth={{base: "0", md: "1px"}}
                    borderColor={{base: "neutral.1100", md: 'neutral.900'}}
                    justifyContent={'space-between'}
                    position={'relative'}
                    w={{base: 'full'}}
                    color={'neutral.600'}
                    _before={{
                        content: '""',
                        position: "absolute",
                        bottom: '3px',
                        right: 0,
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: tabIndex === 2 ? "purple.500" : 'neutral.800',
                        display: {base: "block", md: "none"}
                    }}
                    _selected={{
                        color: 'neutral.100',
                        borderColor: 'purple.500',
                        _after: {
                            content: '""',
                            position: "absolute",
                            bottom: '17px',
                            right: '7px',
                            transform: "translateY(-50%)",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor: "purple.500",
                            display: {base: "block", md: "none"}
                        }
                    }}>
                    <HStack>
                        {tabIndex === 2 ? <ListWhiteIcon/> : <ListIcon/>}
                        <Text>Withdraw</Text>
                    </HStack>
                </Tab>
            </TabList>
            <TabPanels>
                <TabPanel px={0}>
                    <Overview
                        isMobile={isMobile}/>
                </TabPanel>
                <TabPanel px={0}>
                    <Referral/>
                </TabPanel>
                <TabPanel px={0}>
                    <Withdraw />
                </TabPanel>
            </TabPanels>
        </Tabs>
    )
}